import {Types} from "./actions.js";
import {formatDate} from "../scripts/validation";
let date = new Date ();
date.setDate ( date.getDate () + 1 );
date = formatDate(date);
const INITIAL_STATE = {
    lang : "sr",
    insuranceType : "insurance1",
    isSame : true,
    startDate : date,
    endDate : date,

};
export default function (state = INITIAL_STATE, action){
    switch (action.type) {
        case Types.setActiveLang:
            return {
                ...state ,
                lang : action.lang,

            };
        case Types.setSame:
            return {
                ...state ,
                isSame : action.isSame,

            };
        case Types.setStartDate:
            return {
                ...state ,
                startDate : action.startDate,

            };
        case Types.setEndDate:
            return {
                ...state ,
                endDate : action.endDate,

            };
        case Types.setTemplate:
            return {
                ...state ,
                template : action.template,
                product : action.product

            };
        case Types.setCalc:
            return {
                ...state ,
                calc : action.calc,
                no1 : action.no1

            };
        case Types.setGrade:
            return {
                ...state ,
                grade : action.grade,
            };
        default: {
            return {
                ...state ,
            }
        }
    }
}